<template>
  <el-dialog v-model="is_show_postto" title="Recipients" width="800" @close="is_show_postto = false">
    <Loading v-if="loading" />
    <PostTo v-else @close="closePostTo" :creators="ruleForm.recipient_creators" :group="ruleForm.recipient_groups"
      :click_all="ruleForm.click_all" :key="is_show_postto" :type="'tag'"
      :list="{ groupList: groupList, count: ruleForm.post_to_count }" />
  </el-dialog>
</template>

<script setup>

import { ref, getCurrentInstance, onMounted, computed, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { ElDialog } from 'element-plus';
import PostTo from '@/components/storefront/PostTo.vue';
import Loading from '@/components/ui/Loading.vue';

const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const eventBus = app.appContext.config.globalProperties.EventBus;

const loading = ref(false);
const ruleForm = ref({
  post_to: { type: 'all', data: [{ name: 'All' }] },

});

//--------Post to
const is_show_postto = ref(false);
const groupList = ref([]);
const resolver= ref(null);
//+++++++++++++++++++++++++++++++


const data = ref(null);
//++++++++++++++++++++++++++++++++++++++
//++++++++++++++++++++++++++++++++++++++
const open = (getdata) => {
  handleData(getdata);
  is_show_postto.value = true;
  getDropApi();

};

const handleData = (data) => {
 
  ruleForm.value= { ...data };
  ruleForm.value.click_all = (data && data.click_all) || !data ? true : false;
  ruleForm.value.recipient_creators = data && data.recipient_creators ? data.recipient_creators : [];
  ruleForm.value.recipient_groups = data && data.recipient_groups ? data.recipient_groups : [];
};

//postto
const closePostTo = (val) => {
  is_show_postto.value = false;
  if (val) {
    if (val.type === 'all') {
      ruleForm.value.post_to = { type: 'all', data: [{ name: 'All' }] };
      ruleForm.value.recipient_creators = [];
      ruleForm.value.recipient_groups = [];
      ruleForm.value.post_to_count = val.data.count;
      ruleForm.value.click_all = true;
    } else {
      ruleForm.value.post_to = { type: 'pick', data: [...val.data.creator, ...val.data.group] };
      ruleForm.value.recipient_creators = val.data.creator;
      ruleForm.value.recipient_groups = val.data.group;
      ruleForm.value.post_to_count = val.data.count;
      ruleForm.value.click_all = false;
    }

    resolver.value(ruleForm.value); // 👈 關閉時直接回傳
    resolver.value = null;
  }

};

//creators are searched with pagination inside PostTo, so only the tag list is preloaded here
const getDropApi = async () => {
  if (groupList.value.length === 0) {
    loading.value = true;
    const res = await ajax.get('/storefront-curation/get-tag-list');
    groupList.value = res.data.data;
    loading.value = false;
  }
};

//+++++++++++++++++++++++++++++++++++++++++++++++++++++
onMounted(() => {
  eventBus.on('open-recipient-edit-dialog', (data) => {
    resolver.value = data.resolve; 
    open(data);
  });

});

onBeforeUnmount(() => {
  eventBus.off('open-recipient-edit-dialog');
});

</script>

<style lang="scss">

</style>